import useInterval from 'beautiful-react-hooks/useInterval';
import React from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import config from '../../../../../config';
import { isOKMessage, SessionWebhookResponse } from './types';
import { WebsocketApiConnectionContext } from './useWebsocketApiConnectionContext';

export default function WebsocketApiConnectionContextProvider({ children }: { children: React.ReactNode }) {
  const {
    sendJsonMessage, readyState, lastJsonMessage,
  } = useWebSocket<SessionWebhookResponse>(config.Live.WebSocketUrl, {
    reconnectAttempts: Infinity,
    shouldReconnect: () => true,
    reconnectInterval(lastAttemptNumber) {
      if (lastAttemptNumber < 10) {
        return 500;
      }
      return Math.min(2 ** (lastAttemptNumber - 10) * 1000, 60000);
    },
    onError: () => { console.error('Web socket connection error'); },
  });

  React.useEffect(() => {
    if (readyState === ReadyState.OPEN) {
      sendJsonMessage({ cookies: document.cookie, type: 'auth' });
    }
  }, [readyState]);

  useInterval(() => {
    if (readyState === ReadyState.OPEN) {
      sendJsonMessage({ type: 'ping' });
    }
  }, 60000);

  React.useEffect(() => {
    if (isOKMessage(lastJsonMessage)) {
      sendJsonMessage({ type: 'ActionTimestamp', message: 'WebNavigation' });
    }
  }, [lastJsonMessage]);

  const value = React.useMemo(() => ({
    sendJsonMessage,
    lastJsonMessage,
  }), [sendJsonMessage, lastJsonMessage]);

  return (
    <WebsocketApiConnectionContext.Provider value={value}>
      {children}
    </WebsocketApiConnectionContext.Provider>
  );
}
